<div class="card mt-4">
  <h4 class="card-header">Welcome to Entrarit</h4>
  <div class="card-body">
    <!-- <h6>Users from secure api end point</h6>
    <div *ngIf="loading" class="spinner-border spinner-border-sm"></div>
    <ul *ngIf="communities">
      <li *ngFor="let community of communities">{{community.name}} {{community.address}}</li>
    </ul> -->
    <h6 class="text-center mb-20">What do you want to do?</h6>
    <div class="container">
      <div class="row">
        <div class="col-sm text-center">
          <a routerLink="/property"><fa-icon class="l-icon" [icon]="faSearch"></fa-icon></a>
          <p routerLink="/property">Find Property</p>
        </div>
        <div class="col-sm text-center">
          <fa-icon class="l-icon" (click)="checkSubscriptions()" [icon]="faUnlockAlt"></fa-icon>
          <p (click)="checkSubscriptions()">Open Gate(s)</p>
        </div>
        <div class="col-sm text-center">
          <a routerLink="/available-properties/notices"><fa-icon class="l-icon" [icon]="faEnvelope"></fa-icon></a>
          <p routerLink="/available-properties/notices">Messages</p>
        </div>

        <!-- <div class="col-sm text-center">
        <a routerLink="/profile"><fa-icon class="l-icon" [icon]="faUser"></fa-icon></a>
        <p routerLink="/profile">Profile</p>
      </div> -->

    </div>
    @if (!isAdmin()) {
      <div class="row">
        <div class="col-sm text-center">
          <a routerLink="/visitor"><fa-icon class="l-icon" [icon]="faUser"></fa-icon></a>
          <p router="/visitor">Visitor</p>
        </div>
        <div class="col-sm text-center">
          <fa-icon class="l-icon" (click)="openGuestAccess()" [icon]="faKey"></fa-icon>
          <p (click)="openGuestAccess()">Guest Access</p>
        </div>
      </div>
    }
  </div>
  @if (isAdmin()) {
    <div class="container">
      <div class="row">
        <div class="col-sm text-center">
          <fa-icon class="l-icon" [icon]="faBell"></fa-icon>
          <p>Notifications</p>
        </div>
        <div class="col-sm text-center">
          <a routerLink="/available-properties/manage"><fa-icon class="l-icon" [icon]="faUsers"></fa-icon></a>
          <p routerLink="/available-properties/manage">Manage Users</p>
        </div>
        <div class="col-sm text-center" >
          <a routerLink="/available-properties/manage-numbers"><fa-icon class="l-icon" [icon]="faPhoneAlt"></fa-icon></a>
          <p routerLink="/available-properties/manage-numbers">Manage Numbers</p>
        </div>
      </div>
    </div>
  }


  @if (isSuper()) {
    <div class="container">
      <div class="row">
        <div class="col-sm text-center">
          <a routerLink="/user-roles/list"><fa-icon class="l-icon" [icon]="faUserGear"></fa-icon></a>
          <p routerLink="/user-roles/list">User Roles</p>
        </div>
        <div class="col-sm text-center">
          <a routerLink="/user-profiles"><fa-icon class="l-icon" [icon]="faClipboardUser"></fa-icon></a>
          <p routerLink="/user-profiles">User Profiles</p>
        </div>
        <div class="col-sm text-center">
          <a routerLink="/"><fa-icon class="l-icon" [icon]="faCog"></fa-icon></a>
          <p routerLink="/">Settings</p>
        </div>
      </div>
    </div>
  }
  <!-- <div class="btn-icon text-center">
  <img src="assets/search_community.png" (click)="searchCommunities()">
  <p class="btn-icon-txt">Find Property</p>
</div>
<div class="btn-icon text-center">
  <img src="assets/open_community_gate.png" (click)="checkSubscriptions()">
  <p class="btn-icon-txt">Open Gate(s)</p>

</div> -->
</div>
</div>
